module.exports = __webpack_public_path__ + "img/merchandise-picture.7c2a81bf.jpg";